export enum CacheTags {
	Auth = 'auth',
	Candidate = 'candidate',
	'Candidate.Profile' = 'candidate.profile',
	'Candidate.Jobs' = 'candidate.jobs',
	User = 'user',
	'User.AppliedJobs' = 'user.appliedjobs',
}
